import EnvTag from './EnvTag'

export default EnvTag
